// extracted by mini-css-extract-plugin
export default {"list":"list-styles_list__UA5d8"};